export default __webpack_public_path__ + "static/media/touch2.6abc4faa.png";